import React from 'react';

const WithProps = ({children,...props}) => {
    return children(props);
};

export default WithProps;